__turbopack_context__.v({
  "icon": "Value-module__AGgkUW__icon",
  "iconContainer": "Value-module__AGgkUW__iconContainer",
  "root": "Value-module__AGgkUW__root",
  "skele": "Value-module__AGgkUW__skele",
});
